import React from "react";
import { Button } from "@mui/material";

export default function BlueSmallButton({ startIcon, buttonTitle, onClick ,width,borderRadius,endIcon}) {
  return (
    <Button
      variant="contained"
      startIcon={startIcon ? startIcon : ""}
      endIcon={endIcon}
      onClick={onClick}
      sx={{
        borderRadius: borderRadius ?borderRadius : "8px",
        fontSize: "12px",
        fontWeight: 700,
        textTransform: "none",
        backgroundColor: "#572575",
        width: width?width :null ,
        fontFamily:"Inter",
        fontWeight:700,
        px: 3,
        "&:hover": {
          backgroundColor: "#4A1E66",
        },
      }}
    >
      {buttonTitle}
    </Button>
  );
}
